import { useEffect, useState }      from 'react';
import JustificationListModal       from './JustificationListModal';
import { useJustificationPage }     from '../../contexts/JustificationPageContext';
import api                          from '../../services/api'

const __status = (isJustified) => {
	
    if (isJustified) {
	
        return <span className="text-[#06aa06] text-[0.8rem] px-[16px] py-0 rounded-[12px] bg-[#6bf76b70] ">Ok</span>;
    
    }
	
    return <span className="text-[#AA0657] text-[0.8rem] px-[16px] py-0 rounded-[12px] bg-[#f76bc370] ">Não Ok</span>;
}


export default function JustificationListModalContainer (){

    const { 
        
        isJustificationListModalOpen, 
        comparisionData, 
        justificationList, 
        handerCloseJustificationListModal, 
        handerOpenJustificationForm, 
        setComparisionNumber,
        handleUpadeComparisionTable
         
    } = useJustificationPage();
    
    const [loadBarProps, setLoadBarProps] = useState({ 
        isJustified: false, 
        percentage: 0, 
        progress: 0 
    })

    useEffect(() => {

        if (comparisionData) {
            
            const totalWagonsJustified      = justificationList.reduce((acc, curr) => acc + curr.wagons, 0);
            const totalWagonsComparision    = (comparisionData.executed - comparisionData.planned);
            
            setLoadBarProps({
                isJustified:    __status(comparisionData.isJustified),
                comparation:     `${totalWagonsJustified}/${totalWagonsComparision}`,
                progress:       ((Number(totalWagonsJustified)/Number(totalWagonsComparision)) * 100) > 100 ? 100 : ((Number(totalWagonsJustified)/Number(totalWagonsComparision)) * 100),
            })
            setComparisionNumber(`${totalWagonsJustified}/${totalWagonsComparision}`)
        }

    }, [comparisionData])

    return(

        <JustificationListModal 
            isOpen={isJustificationListModalOpen}
            onClose={handerCloseJustificationListModal}
            onOpenJustificationForm={handerOpenJustificationForm}
            loadBarProps={loadBarProps}
        />
    )
}